import React from "react";
import { BrowserRouter } from "react-router-dom";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import "antd/dist/reset.css";

import store from "./core/redux/store.jsx";
import AllRoutes from "./core/router/router.jsx";

// =======
// CSS
// =======
import "bootstrap/dist/css/bootstrap.min.css";

import * as bootstrap from "bootstrap";

if (typeof window !== "undefined") {
  window.bootstrap = bootstrap;
}

import "../src/style/css/feather.css";
import "../src/style/css/line-awesome.min.css";
import "../src/style/scss/main.scss";
import "../src/assets/icons/fontawesome/css/fontawesome.min.css";
import "../src/assets/icons/fontawesome/css/all.min.css";

const rootElement = document.getElementById("root");

if (rootElement) {
  const root = createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <Provider store={store}>
        <BrowserRouter>
          <AllRoutes />
        </BrowserRouter>
      </Provider>
    </React.StrictMode>,
  );
} else {
  console.error("Element with id 'root' not found.");
}
